import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { KTSVG } from '../../../../_myb/helpers';
import './customModal.css';

interface CustomModalProps {
  id: string;
  title: string;
  body: React.ReactElement<any>;
  onSave?: () => void;
  noScaffolding?: boolean;
  showFooter?: boolean;
  isVisible: boolean;
  onClose: () => void;
  size?: 'small' | 'medium' | 'wide' | 'large';
}

const CustomModal: React.FC<CustomModalProps> = ({
  id,
  title,
  body,
  onSave,
  isVisible,
  noScaffolding = false,
  onClose,
  showFooter,
  size = 'medium',
}) => {
  const getSizeClass = () => {
    switch (size) {
      case 'small':
        return 'sm';
      case 'wide':
        return 'lg';
      case 'large':
        return 'xl';
      default:
        return undefined; // Default size
    }
  };

  return (
    <Modal
      show={isVisible}
      onHide={onClose}
      size={getSizeClass()}
      aria-labelledby={id}
      centered
      scrollable
      // backdrop={}
      className={noScaffolding ? 'p-0' : ''}
    >
      
        <Modal.Header closeButton>
          <Modal.Title id={id}>{title}</Modal.Title>
          {/* <Button
            variant="icon btn-sm btn-active-light-primary ms-2"
            aria-label={'Close'.toTranslatedDisplay()}
            onClick={onClose}
          >
            <KTSVG
              path="media/icons/duotune/arrows/arr061.svg"
              className="svg-icon svg-icon-2x"
            />
          </Button> */}
        </Modal.Header>
      
      <Modal.Body
        className={noScaffolding ? 'p-0' : ''}
      >
        {body}
      </Modal.Body>
      {showFooter && onSave && (
        <Modal.Footer>
          <Button variant="primary" onClick={onSave}>
            {'Save'.toTranslatedDisplay()}
          </Button>
          <Button variant="secondary" onClick={onClose}>
            {'Close'.toTranslatedDisplay()}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
